<div class="course-layout">
	<msc-sidebar *ngIf="displays.sidebar" class="course-layout__sidebar" [course]="course" [showSidebar]="showSidebar"
		[external]="external" (closeSidebar)="closeSidebar()"></msc-sidebar>

	<!-- Backdrop solo en mobile: la visibilidad la controla la clase .sidebar-open via CSS -->
	<div class="course-layout__backdrop" *ngIf="displays.sidebar" (click)="closeSidebar()"></div>

	<div class="course-layout__main">
		<!--
		<msc-topbar *ngIf="displays.topbar" [course]="course" [courseSubscriptionSession]="courseSubscriptionSession"
			[showSidebar]="showSidebar" [displaySidebar]="displays.sidebar" (toggle)="toggleSidebar()"></msc-topbar>-->

		<div id="view"
			[ngClass]="{'view-activity': !displays.sidebar, 'view__external': external}">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>

<style>
	.course-layout {
		display: flex;
		align-items: flex-start;
		gap: 1.5rem;
	}

	.course-layout__sidebar {
		flex: 0 0 290px;
		max-width: 290px;
		position: sticky;
		top: 0;
		/* flex-start (no stretch): el sidebar toma solo la altura de su contenido en
		   lugar de estirarse a la altura del #view, evitando el espacio en blanco.
		   Además permite que el sticky funcione al hacer scroll. */
		align-self: flex-start;
	}

	.course-layout__main {
		flex: 1 1 auto;
		min-width: 0;
		display: flex;
		flex-direction: column;
	}

	.course-layout__main #view,
	.course-layout__main div#view {
		top: 0 !important;
		z-index: 9999;
	}

	.course-layout__main header {
		width: 100% !important;
		transform: none !important;
	}

	.view-activity {
		position: static !important;
	}

	.view__external {
		top: 0 !important;
	}

	/* Hamburguesa, close-mobile y backdrop: ocultos SIEMPRE en desktop */
	.course-layout__hamburger,
	::ng-deep .course-layout__hamburger,
	::ng-deep .sidebar__close-mobile,
	.course-layout__backdrop {
		display: none !important;
	}

	/* ===== Responsive: tablet/mobile (≤1024px) ===== */
	@media (max-width: 1024px) {
		.course-layout {
			flex-direction: column;
		}

		.course-layout__sidebar {
			position: fixed;
			top: 0;
			left: 0;
			height: 100vh;
			max-height: 100vh;
			width: 100vw;
			max-width: 100vw;
			z-index: 1000;
			background: #fff;
			transform: translateX(-100%);
			/* Duración usada al CERRAR (estado base): más lenta */
			transition: transform 0.55s ease;
			/*	box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);*/
			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
			overscroll-behavior: contain;
		}

		/* Permitir que el contenido interno fluya y se pueda scrollear todo */
		::ng-deep .course-layout__sidebar #sidebar,
		::ng-deep .course-layout__sidebar aside.sidebar-new {
			height: auto !important;
			min-height: 0 !important;
			max-height: none !important;
			overflow: visible !important;
			/* #sidebar tiene width: 19rem fijo en legacy.css: forzar ancho completo en mobile */
			width: 100% !important;
		}

		::ng-deep .course-layout__sidebar aside.sidebar-new > div {
			overflow: visible !important;
			margin: 0 !important;
			border-radius: 0 !important;
			box-shadow: none !important;
		}

		::ng-deep .course-layout__sidebar .module-list {
			overflow: visible !important;
			max-height: none !important;
		}

		/* Espacio inferior para que el último item no quede pegado al borde */
		::ng-deep .course-layout__sidebar aside.sidebar-new {
			padding-bottom: 4rem !important;
		}

		.course-layout.sidebar-open .course-layout__sidebar {
			transform: translateX(0);
			z-index: 99999;
			/* Duración usada al ABRIR: más rápida que el cierre */
			transition: transform 0.3s ease;
		}

		.course-layout__backdrop {
			display: block !important;
			position: fixed;
			inset: 0;
			background: rgba(15, 23, 42, 0.55);
			/* Por encima del contenido (#view: z-index 9999) y por debajo del
			   drawer (.sidebar-open .course-layout__sidebar: z-index 99999) */
			z-index: 99990;
			opacity: 0;
			visibility: hidden;
			pointer-events: none;
			transition: opacity 0.55s ease, visibility 0.55s ease;
		}

		.course-layout.sidebar-open .course-layout__backdrop {
			opacity: 1;
			visibility: visible;
			pointer-events: auto;
			transition: opacity 0.3s ease, visibility 0.3s ease;
		}

		.course-layout__main {
			width: 100%;
		}

		/*msc-topbar {
			position: relative;
			z-index: 999;
		}*/

		/* En mobile el hamburger del topbar reemplaza a los botones expand/collapse */
		.course-layout__expand-btn,
		::ng-deep .course-layout__expand-btn,
		::ng-deep .sidebar__collapse-desktop {
			display: none !important;
		}

		/* Close button del sidebar visible solo en mobile */
		::ng-deep .sidebar__close-mobile {
			display: inline-flex !important;
		}

		/* Hamburger DENTRO del topbar: ocupa el lugar del expand-btn */
		.course-layout__hamburger,
		::ng-deep .course-layout__hamburger {
			display: inline-flex !important;
			align-items: center;
			justify-content: center;
			width: 36px;
			height: 36px;
			border: 1px solid #E8EAEF;
			border-radius: 8px;
			background: #fff;
			color: #22304C;
			cursor: pointer;
		}
	}

	@media (max-width: 768px) {

		.course-layout__main #view,
		.course-layout__main div#view {
			top: 0rl px !important;
			z-index: 9999;
		}
	}
</style>